// images
import tireImage from './images/tire_sizes.jpg';
import truckImage from './images/trucks.jpg';
import truckRulesImage from './images/truck_rules.jpg';
import plateImage from './images/truck_plate.jpg';
import correctiveActionsImage from './images/corrective_actions.png';
import claimsImage from './images/claims.jpg';
import outOfServiceImage from './images/out_of_service.jpg';
import truckRentalImage from './images/truck_rental.jpg';
import assignImage from './images/assign_loads_img.png';
import hazmatImage from './images/hazmat.jpg';

const pages = [
  {
    text: 'Tire Sizes',
    image: tireImage,
    path: '/safety/safety-table-maints/tire-sizes',
  },
  {
    text: 'Truck Makes',
    image: truckImage,
    path: '/safety/safety-table-maints/truck-makes',
  },
  {
    text: 'Truck Models',
    image: truckImage,
    path: '/safety/safety-table-maints/truck-models',
  },
  {
    text: 'Truck Permit Rules',
    image: truckRulesImage,
    path: '/safety/safety-table-maints/truck-permit-rules',
  },
  {
    text: 'Plate Types',
    image: plateImage,
    path: '/safety/safety-table-maints/plate-types',
  },
  {
    text: 'Corrective Action Types',
    image: correctiveActionsImage,
    path: '/safety/safety-table-maints/corrective-action-types',
  },
  {
    text: 'Corrective Action Subjects',
    image: correctiveActionsImage,
    path: '/safety/safety-table-maints/corrective-action-subjects',
  },
  {
    text: 'Lien Holders',
    image: claimsImage,
    path: '/safety/safety-table-maints/lien-holders',
  },
  {
    text: 'Out of Service Reasons',
    image: outOfServiceImage,
    path: '/safety/safety-table-maints/out-of-service-reasons',
  },
  {
    text: 'Truck Reassignment Reasons',
    image: assignImage,
    path: '/safety/safety-table-maints/truck-reassignment-reasons',
  },
  {
    text: 'Rental Companies',
    image: truckRentalImage,
    path: '/safety/safety-table-maints/rental-companies',
  },
  {
    text: 'Terminate Reasons',
    image: outOfServiceImage,
    path: '/safety/safety-table-maints/terminate-reasons',
  },
  {
    text: 'DQF Files',
    image: claimsImage,
    path: '/safety/safety-table-maints/dqf-files',
  },
  {
    text: 'Hazmat Classes',
    image: hazmatImage,
    path: '/safety/safety-table-maints/hazmat-classes',
  },
  {
    text: 'Email Addresses',
    image: claimsImage,
    path: '/safety/safety-table-maints/email-addresses',
  }
];

export default pages;
